class ExtendedPool {
    constructor(prefab, initialPoolSize = 0, type = null) {
        this.prefab = prefab;
        if (type !== null) {
            this.pool = new cc.NodePool(type);
        } else {
            this.pool = new cc.NodePool();
        }

        for (let i = 0; i < initialPoolSize; i++) {
            this.pool.put(cc.instantiate(this.prefab));
        }
    }
    get() {
        if (this.pool.size()) {
            return this.pool.get();
        } else {
            return cc.instantiate(this.prefab);
        }
    }
    set(node) {
        node.parent = null;
        this.pool.put(node);
    }
}


export default ExtendedPool;
